import { all } from 'redux-saga/effects';

import * as couponsActivity from './couponsActivity';
import * as list from './list';
import * as newUsedCoupons from './newUsedCoupons';

export default function* saga() {
  yield all([couponsActivity.saga(), list.saga(), newUsedCoupons.saga()]);
}
